import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { environment } from 'src/environments/environment';
import { IEmployee } from 'src/app/tabms/models/self-services/employees/employee';
import { BaseService } from 'src/app/tabms/services/base/base.service';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-self-services-details',
  templateUrl: './self-services-details.component.html',
  styleUrl: './self-services-details.component.scss'
})
export class SelfServicesDetailsComponent {
  @Input() profileImage: string;
  @Input() empDetails: IEmployee;
  // base: string = environment.filesUrl;
  currentLang: string;
  constructor(private baseServie: BaseService, private translate: TranslateService) {
    this.currentLang = this.baseServie.getCurrentLanguage();
  }

  branch$: Observable<string>;
  department$: Observable<string>;
  ngOnInit() {
    setTimeout(() => { // تأخير تعيين القيمة
      this.branch$ = this.translate.stream('branch'); 
      this.department$ = this.translate.stream('department');
    }); 
  }
}
